import { fun_PostAction, fun_Download } from "@/api";
import { fun_DownloadFile } from "@/utils/validate";
// 导出
export default {
  // 数据存储
  data: () => {
    // 返回
    return {
      // 下载标书弹窗状态
      dialogDownload: false,
      // 下载标书弹窗列表配置
      tableColumnsDownload: [
        {
          label: "名称",
          prop: "fileName"
        },
        {
          label: "时间",
          prop: "insertDate"
        },
        {
          label: "操作",
          slotName: "op"
        }
      ],
      // 下载标书弹窗列表数据
      tableDataDownload: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      recordNumber: null, // 关联数据
      flag: null // 标识，判定是否带上最新的附件
    };
  },
  // 自定义方法
  methods: {
    /**
     * 点击下载
     * @author 滕威
     */
    fun_BidDownload(e) {
      // 下载文件
      fun_Download("/download?filePath=" + e.filePath).then(res => {
        // 获取头部
        let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
        let regFileNames = fileNames.match(/=(.*)$/)[1];
        // 调用下载文件公共方法
        fun_DownloadFile(res, decodeURIComponent(regFileNames));
      });
    },
    /**
     * 获取列表数据
     * @author 滕威
     */
    async fun_GetList() {
      let res = await fun_PostAction(
        "/fileInfo/fileInfoList?recordNumber=" +
          this.recordNumber +
          "&fileType=word" +
          "&flag=" +
          this.flag
      );
      // 解构res.data
      const { result, data, msg } = res.data;
      if (result) {
        // 回显列表
        this.tableDataDownload = data.records;
        // 总数
        this.total = data.total;
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    }
  }
};
